<template>
    <div class="dd-avatar">
        <div :class="{'avatar-image':useImage }" class="dd-avatar-container" :color="color" :style="`width:${avatarSize}px; height:${avatarSize}px; background-color:${color}; background-image:url('${useImage}${cacheString}')`">                    
            <span v-if="!useImage" class="avatar-text" :style="`font-size:${avatarTextSize}`">{{avatarText}}</span>
        </div>
    </div>
</template>
<script>
    import ColorHash from 'color-hash';
    import { IMAGE_URL } from "../../config.js"

    export default {
        props: {
            user: { // prop for building avatar based on user
                type:Object                
            },
            cacheValue:{
                default:0
            },
            label:{ // prop for building avatar based on given name
                type:String
            },
            size:{
                type:String
            },
            image:{
                type:String
            }
        },        
        data() {
            return {   
                defaultIcon: "fas fa-user-circle",
                defaultSize: "normal",
                sizes:{
                    "small":{
                        "font": {
                            1:"10px",
                            2:"8px",
                            3:"6px"
                        }, 
                        "avatar": 20, 
                    },
                    "normal":{
                        "font": {
                            1:"20px",                            
                            2:"18px",
                            3:"14px"
                        }, 
                        "avatar": 36
                    },
                    "bit-larger":{
                        "font": {
                            1:"20px",                            
                            2:"18px",
                            3:"14px"
                        }, 
                        "avatar": 54
                    },
                    "large":{
                        "font": {
                            1:"42px",                                                        
                            2:"32px",
                            3:"24px"
                        },
                        "avatar": 72
                    },
                    "extra-large":{
                        "font": {
                            1:"80px",                             
                            2:"54px",
                            3:"44px"
                        },
                        "avatar": 124                    
                    },
                    "xxl":{
                        "font": {
                            1:"120px",                             
                            2:"80px",
                            3:"60px"
                        },
                        "avatar": 172               
                    }                    
                }
            }
        },
        computed: {
            firstName(){
                if(this.user.person && this.user.person.firstName)
                    return this.user.person.firstName 
                else if(this.user.firstName)
                    return this.user.firstName
                else
                    return ""                    
            },
            lastName(){
                if(this.user.person && this.user.person.lastName)
                    return this.user.person.lastName 
                else if(this.user.lastName)
                    return this.user.lastName
                else
                    return ""   
            },
            useImage(){                
                if(this.image)
                    return this.image
                if(this.user && this.user.avatar)
                    return IMAGE_URL+"/"+this.user.avatar.publicLocation

                return false
            },
            cacheString(){
                return this.cacheValue == 0 ? "" : "?nocache="+this.cacheValue;
            },            
            avatarText(){
                if(this.label){
                    let tmp1 = [];  // firstname
                    let tmp2 = this.label.split(" ") //lastname             
                    if(tmp2.length > 1) 
                        tmp1 = tmp2.shift().split("-"); 
                    return this.createShort([...tmp1, ...tmp2]);                                                
                }
                if(this.user){
                    // user mananager uses flat user object make compatible
                    return this.createShort([...this.firstName.split("-"), ...this.lastName.split(" ")]);
                }
                return "?";
            },
            avatarTextSize(){
                let sz = this.size ? this.size : this.defaultSize;
                return this.sizes[sz]["font"][this.avatarText.length];
            },
            avatarSize(){
                let sz = this.size ? this.size : this.defaultSize;
                return this.sizes[sz]["avatar"];
            },
            color(){
                let colorHash = new ColorHash();
                if(this.label){
                    return colorHash.hex(this.label);                                               
                }
                if(this.user){
                    return colorHash.hex(this.firstName+" "+this.lastName);
                }
                return colorHash.hex("?");                                    
            }
        },
        methods: {
            createShort(arr) {                
                let text = "";
            
                for(var i in arr){
                    if(arr[i][0]){
                        text += arr[i][0]
                    }
                }

                if(text.length==0)
                    return "?"

                // if text array is longer then 3, take first character (firstname letter) and 2 characters from the back of the lastname array
                if(text.length > 3){
                    let tmp = text[0];
                    tmp += text[text.length-2];
                    tmp += text[text.length-1];
                    text = tmp;
                }
                return text;
            }
        }        
    }
</script>

<style scoped>
    .dd-avatar{
        flex: initial;
    }
    .dd-avatar-container{
        border-radius:50%;
        display:flex;
        align-items: center;
        justify-content: center;        
    }

    .avatar-image{
        margin:0px;
        padding:0px;
        border-radius:50%;
        display:flex;
        background-size:cover;
        background-position: center top;

    }

    .avatar-text{ 
        color:rgba(255, 255, 255, 0.9) !important;
    }
</style>